
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.86 10.61l1.382-1.172.43.507-3.735 3.742h-.5L.704 9.945l.43-.508L2.5 10.602V3.516L1.133 4.68l-.43-.508L4.438.43h.5l3.734 3.742-.43.508L6.86 3.508v7.101zm-3.25.867l1.078.867 1.062-.852V2.625l-1.063-.852-1.078.868v8.836z","fill":"currentColor"}})])
          )
        }
      }
    